export default __webpack_public_path__ + "static/media/List-documentation.bd8582f3.md";